function configureUserIdentityManager(config) {
  userIdentityManager.logout = config.logout;
  userIdentityManager.requestLogin = config.requestLogin;
}
const userIdentityManager = {
  requestLogin: () => {
    console.warn(
      "UserIdentityManager has not beed configured yet, a call to configureUserIdentityManager() is required before accessing manager.requestLogin()"
    );
  },
  logout: () => {
    console.warn(
      "UserIdentityManager has not beed configured yet, a call to configureUserIdentityManager() is required before accessing manager.logout()"
    );
  }
};

export { configureUserIdentityManager, userIdentityManager };
//# sourceMappingURL=user-identity.manager.js.map
